import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface KitchenParamsState {
  params: any; // Define a more specific type if possible
}

const initialState: KitchenParamsState = {
  params: null,
};

const kitchenSliceParams = createSlice({
  name: 'kitchenParams',
  initialState,
  reducers: {
    setKitchenParams(state, action: PayloadAction<any>) {
      state.params = action.payload;
    },
  },
});

export const { setKitchenParams } = kitchenSliceParams.actions;
export default kitchenSliceParams.reducer;
